import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-zrjg",
  "use": "icon-map-zrjg-usage",
  "viewBox": "0 0 22 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 18\" id=\"icon-map-zrjg\">\n<style type=\"text/css\">\n\t#icon-map-zrjg .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<g>\n\t<polygon class=\"st0\" points=\"17,18 22,18 16,4 14,11 \t\" />\n\t<path class=\"st0\" d=\"M8,0L0,18h16L8,0z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol